import styled from "@emotion/styled";
import { Alert } from "@mui/material";

export const NotificationToast = styled(Alert)`
    position: fixed;
    top: 10px;
    right: 10px;
    width: 30%;
    z-index: 6;
`;